<template>
    <div class="d-inline-block">
        <x-btn
            class="ma-0"
            color="tertiary"
            :small="small"
            @click.stop="deleteQuote"
        >
            <i class="material-icons-outlined mr-2">delete_forever</i>

            Delete quote
        </x-btn>

        <modal
            ref="confirmQuoteDelete"
            title="Delete quote"
            confirmation
        >
            <p>You are about to delete the current quote, are you sure?</p>
        </modal>
    </div>
</template>

<script>
    import Modal from '~/components/Shared/UIComponents/Modal';

    export default {
        name: 'DeleteQuoteButton',
        components: {
            Modal
        },
        props: {
            submissionId: {
                type: Number,
                required: true
            },
            small: {
                type: Boolean,
                default: false
            }
        },
        methods:{
            async deleteQuote() {
                if (await this.$refs.confirmQuoteDelete.open() === true) {
                    await axios.delete(this.$root.api(`broker/submission/${this.submissionId}`));
                    this.$router.push('/agent/dashboard/');
                }
            },
        }
    }
</script>
